import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { DepartmentSpotlightRoutingModule } from './department-spotlight-routing.module';
import { DepartmentSpotlightListComponent } from './department-spotlight-list/department-spotlight-list.component';
import { DepartmentSpotlightCreateComponent } from './department-spotlight-create/department-spotlight-create.component';

@NgModule({
  declarations: [DepartmentSpotlightListComponent, DepartmentSpotlightCreateComponent],
  imports: [
    CommonModule,
    DepartmentSpotlightRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class DepartmentSpotlightModule { }
